import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getCommentList } from '../../../api/comments';

import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import { REQUEST } from '../../../constants/request';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeCommentListWithUserData } from '../../../utils/comments';

// TODO: check the correctness of work after implementation on the backend

export const fetchNestedComments = createAsyncThunk(
  'comments/fetchNestedComments',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentsResponse, userDataMapResponse] = await getCommentList(
        commentData,
        {
          cancelToken: source.token,
        },
      );
      return {
        data: mergeCommentListWithUserData(
          commentsResponse,
          userDataMapResponse,
        ),
      };
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path, params }, { getState }) => {
      const { comments } = getState().comments;
      const commentCIDKey = generateCommentCIDKey({ ...path, ...params });

      return (
        comments.parent.request[commentCIDKey]?.loading !== REQUEST.pending
      );
    },
  },
);

export const fetchNestedCommentsExtraReducers = builder => {
  builder
    .addCase(fetchNestedComments.pending, (state, action) => {
      const { path, params } = action.meta.arg;
      const commentCIDKey = generateCommentCIDKey({ ...path, ...params });

      checkAndSetLoadingWithId(
        state.comments.parent.request,
        action,
        commentCIDKey,
      );
    })
    .addCase(fetchNestedComments.fulfilled, (state, action) => {
      const { path, params } = action.meta.arg;
      const commentCIDKey = generateCommentCIDKey({ ...path, ...params });

      onMatchedRequest(
        state.comments.parent.request[commentCIDKey],
        action,
        () => {
          action.payload.data.comments.forEach(comment => {
            const currentCommentCIDKey = generateCommentCIDKey(comment);
            state.comments.comment.byId[currentCommentCIDKey] = comment;
            if (!state.comments.comment.allIds.includes(currentCommentCIDKey)) {
              state.comments.comment.allIds.push(currentCommentCIDKey);
            }
            if (!state.comments.item.byId[commentCIDKey]) {
              state.comments.item.byId[commentCIDKey] = [];
            }
            if (!state.comments.parent.byId[commentCIDKey]) {
              state.comments.parent.byId[commentCIDKey] = [];
            }
            if (
              !state.comments.parent.byId[commentCIDKey].includes(
                currentCommentCIDKey,
              )
            ) {
              state.comments.parent.byId[commentCIDKey].push(
                currentCommentCIDKey,
              );
            }
            if (
              !state.comments.parent.byId[currentCommentCIDKey] &&
              comment.metadata.replies > 0
            ) {
              state.comments.parent.byId[currentCommentCIDKey] = [];
            }
          });
        },
      );
    })
    .addCase(fetchNestedComments.rejected, (state, action) => {
      const { path, params } = action.meta.arg;
      const commentCIDKey = generateCommentCIDKey({ ...path, ...params });

      handleRequestRejection(
        state.comments.parent.request[commentCIDKey],
        action,
      );
    });
};
